export const formatterRubWithCurrency = new Intl.NumberFormat('ru', {
  style: 'currency',
  currency: 'RUB',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
  currencyDisplay: 'code',
})

export const formatterRub = new Intl.NumberFormat('ru', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
})

const formatterUsdtWithCurrency = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD', // для корректной обработки форматирования
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
  currencyDisplay: 'code',
})

export const formatUsdt = (value: number) =>
  formatterUsdtWithCurrency.format(value).replace('USD', 'USDT')

export const formatPercent = (value: number): string => {
  return `${parseFloat((value * 100).toFixed(2))}%`
}
